import NavBar from "../Componants/NavBar";
import HomeSection from "../Componants/HomeSection";
import SubscriptionSection from "../Componants/SubscriptionSection";
import React, {useEffect,useState} from "react";
import {useNavigate, useLocation, useParams} from 'react-router-dom';
import {Ajax} from "../Service/ajax";
import {GridLoader} from "react-spinners";
import Footer from "../Componants/Footer";
import Swal from "sweetalert2";
import {plans, plans_pl, plans_pm} from "../env/Environment";
import DisconnectedSection from "../Componants/DisconnectedSection";
import PricingPlansComparison from "../Componants/PricingPlansComparison";
export default function HomeView(){
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const session = sessionStorage.getItem("session");
    const { pageUrl } = useParams();
    const [appName, setAppName]=useState('');
    const [sub, setSub]=useState('');
    const [cmp, setCmp]=useState('');
    const [description, setDescription]=useState('');
    const [subscriptions, setSubscriptions]=useState([]);
    useEffect(() => {
        document.title = "Netikash Subscribe - "+appName;
    }, [appName]);

    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState("default");


    useEffect(() => {
        const uniqueCategories = [];

        subscriptions.forEach((item) => {
            const category = item.category || "default";
            if (!uniqueCategories.includes(category)) {
                uniqueCategories.push(category);
            }
        });

        setCategories(uniqueCategories);
        setCategory(uniqueCategories[0])
    }, [subscriptions]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const {data} = await Ajax.getRequest(`/exposed/v1/sub/application/retrieve/page?page=${pageUrl}`);
                setAppName(data.object.name);
                setDescription(data.object.description);
                setSub(data.object.sub_id);
                setCmp(data.object.cmp);
                if(!data.object.sub_id){
                    Swal.fire({
                        title: 'Oops!',
                        text: "Aucune page d'abonnement n'est trouvé, veillez demandez fournisseur de vous renvoyer a nouveau",
                        icon: 'info',
                        confirmButtonText: 'OK',
                        timer: 10000
                    }).then((result) => {
                        if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
                            setLoading(false)
                            navigate("/");
                        }
                    });
                }else if(data.object.sub_id === plans.evaluation || data.object.sub_id === plans_pm.standard || data.object.sub_id === plans_pm.basic || data.object.sub_id === plans_pm.pro || data.object.sub_id === plans_pm.entreprise || data.object.sub_id === plans_pl.standard || data.object.sub_id === plans_pl.basic || data.object.sub_id === plans_pl.pro || data.object.sub_id === plans_pl.entreprise){
                    if(data.object.subscriptionPlans.length > 0){
                        const transformedPlan = data.object.subscriptionPlans.map(item => {
                            return {
                                id:item.id,
                                title: item.title,
                                infos: item.infos,
                                options: item.values,
                                price: item.price,
                                periodicity: item.periodicity,
                                currency:item.devise,
                                category:item.category ? item.category : 'default',
                            };
                        });
                        setSubscriptions(transformedPlan);
                    }else{
                        Swal.fire({
                            title: 'Oops!',
                            text: "Aucun pack d'abonnement disponible sur cette page",
                            icon: 'info',
                            confirmButtonText: 'OK',
                            timer: 10000
                        }).then((result) => {
                            if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
                                navigate("/");
                            }
                        });
                    }
                }else{
                    setLoading(true)
                    Swal.fire({
                        title: 'Oops!',
                        text: "Aucune page d'abonnement n'est trouvé, veillez demandez fournisseur de vous renvoyer a nouveau",
                        icon: 'info',
                        confirmButtonText: 'OK',
                        timer: 10000
                    }).then((result) => {
                        if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
                            setLoading(false)
                            navigate("/");
                        }
                    });
                }
            } catch (error) {
                navigate("/error-page", { state: { errorCode: error.response.status } });
            }finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);
    return(
        <>
            {loading ? (
                <div className="loading-overlay">
                    <div className="loading-spinner">
                        <GridLoader
                            color="#debf66"
                            loading
                            size={15}
                        />
                    </div>
                </div>
            ) : (
                <div className="layout-wrapper layout-content-navbar layout-without-menu">
                    <div className="layout-container">
                        <div className="layout-page">
                            <NavBar/>
                            <div className="content-wrapper">

                                <div className="container-xxl flex-grow-1 container-p-y">
                                    <div className="layout-demo-wrapper">
                                        <HomeSection title={appName} description={description} cmpParam={cmp} page={true}/>
                                    </div>
                                </div>


                                <div className="container-xxl flex-grow-1 container-p-y">
                                    <SubscriptionSection appName={appName} appDescription={description}
                                                         subscriptions={subscriptions} cmp={cmp} user={true} category={category} setCategory={setCategory} categories={categories}/>
                                </div>
                                <div className="container-xxl flex-grow-1 container-p-y">
                                    <PricingPlansComparison subscriptions={subscriptions} category={category}/>
                                </div>
                                {!session &&
                                    <div className="container-xxl flex-grow-1 container-p-y">
                                        <DisconnectedSection/>
                                    </div>
                                }
                                <div className="content-backdrop fade"></div>
                            </div>
                            <Footer/>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
